import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import { Button } from "@thrivetribe/gloji.ui.atoms.button";
import {
  ModalPageBody,
  ModalPageCopy,
  ModalPageFooter,
  ModalPageHeading,
  ModalPageWrapper,
} from "../../../organisms/ModalPage";
import { CircularLoader } from "../../../atoms/Loaders";

import "./UserDetails.scss";
import useUserId from "../../../hooks/useUserId";
import { useGetProfileByIdQuery } from "../../../../redux/profileApiV3";
import { skipToken } from "@reduxjs/toolkit/dist/query";

const UserDetails = () => {
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const [userId] = useUserId();
  const {
    data: profile,
    isSuccess: getProfileSuccessful,
    isUninitialized,
  } = useGetProfileByIdQuery(userId ?? skipToken);

  useEffect(() => {
    if (getProfileSuccessful && !isUninitialized) {
      setLoading(false);
    }
  }, [getProfileSuccessful, isUninitialized]);

  const handleLetsDoIt = () => {
    return history.push("/book");
  };

  if (loading) {
    return <CircularLoader />;
  }

  return (
    <>
      <Helmet>
        <title>Time to book your first appointment | Gloji</title>
      </Helmet>

      <ModalPageWrapper>
        <ModalPageBody hasStickyFooter={false}>
          <ModalPageHeading size="large">Time to book your first appointment!</ModalPageHeading>
          <ModalPageCopy>
            We'll get in touch using the contact details you gave us when you signed up.
          </ModalPageCopy>

          <div className="user-details">
            <div className="user-details__info">
              <span className="user-details__info__title">Email</span>
              <span>{profile?.personalDetails?.email}</span>
            </div>
            <div className="user-details__info">
              <span className="user-details__info__title">Phone</span>
              <span>{profile?.personalDetails?.phoneNumber}</span>
            </div>
          </div>
        </ModalPageBody>

        <ModalPageFooter hasStickyFooter={false}>
          <Button onClick={() => handleLetsDoIt()}>Let's do it</Button>
        </ModalPageFooter>
      </ModalPageWrapper>
    </>
  );
};

export default UserDetails;
